import React, { useEffect, useState } from "react";
import {
    Paper,
    makeStyles,
    AppBar,
    Toolbar,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Radio,
    Button,
    IconButton,
    Typography,
    TextField,
    InputAdornment,
    Grid
} from "@material-ui/core";
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import Autocomplete from '@material-ui/lab/Autocomplete';
import relianceLogo from '../../../assets/reliance-logo.png';
import mapIcon from '../../../assets/map-icon.png';
import { connect } from "react-redux";
import { compose } from 'redux';
// import { geolocated } from "react-geolocated";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from 'leaflet';
import { searchFuelPumps, getSuggestedCities } from "../../../store/actions/userActionCreators";
import queryString from "query-string";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import throttle from 'lodash/throttle';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import MarkerClusterGroup from 'react-leaflet-markercluster';
// import Control from 'react-leaflet-control';
import { NearByIcon } from "../../../components/icons";
import RoomIcon from '@material-ui/icons/Room';
import { useLocation } from "react-router-dom";

const useStyles = makeStyles(() => ({

    container: {
        //height: '100vh',8
        backgroundColor: 'white',
        paddingTop: '16px',
        paddingBottom: '16px',
        borderRadius: 8,
        width: '290px'
    },
    relianceHeaderCard: {
        display: "flex",
        alignItems: "center",
        justifyContent: 'center',
        backgroundColor: "#f1f7ff",
        padding: "8px 0px"
    },
    bunkHeaderCard: {
        display: "flex",
        alignItems: 'center',
        //padding:"8px 0px",
        marginLeft: 16,
        paddingTop: 16,
        paddingBottom: 12
    },
    bunkTxt: {
        fontSize: 16,
        color: "#1f2940",
        marginLeft: 16
    },
    relianceLogo: {
        width: 24,
        height: 24,
    },
    headerTxt: {
        fontSize: '12px !important',
        color: "#1f2940",
        backgroundColor: "#e4efff",
        marginLeft: 8
    },
    searchContainer: {
        marginTop: 16,
        paddingLeft: 16,
        paddingRight: 16
    },
    mapContainer: {
        marginTop: 16
    },
    icon: {
        fontSize: 24,
        color: "#6b778c"
    },
    listHead: {
        color: "#0b1323",
        fontSize: '14px !important'
    },
    listHeader: {
        marginTop: 16,
        marginBottom: 24,
        marginLeft: 20,
        marginRight: 20
    },
    listContainer: {
        marginRight: 14,
        marginLeft: 16,
        overflow: 'auto',
        height: "calc(100vh - 550px)"
    },
    listContainer1: {
        marginRight: 14,
        marginLeft: 16,
        overflow: 'auto',
        height: "calc(100vh - 530px)"
    },
    listContainer2: {
        marginRight: 14,
        marginLeft: 16,
        overflow: 'auto',
        height: "calc(100vh - 550px)"
    },
    listBox: {
        border: "solid 2px #dfe4f0",
        backgroundColor: "#fff",
        borderRadius: 8,
        padding: "8px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: 'space-between',
        marginBottom: 8,
        marginRight: 2,
        cursor: 'pointer'
    },
    pumpName: {
        color: "#0b1323",
        fontSize: 12,
        fontWeight: 600
    },
    bunkName: {
        color: "#0b1323",
        fontSize: 12,
        fontWeight: 600
    },
    bunkLocation: {
        color: "rgba(11, 19, 35, 0.75)",
        fontSize: 12,
        marginTop: 2,
        marginBottom: 4
    },
    pumpLocation: {
        color: " rgba(17, 35, 11, 0.59)",
        fontSize: 12,
        marginTop: 2
    },
    indicator: {
        color: "#315BD5",
        fontSize: 24,
    },
    backArrow: {
        //fontSize:16,
        color: "#000",
        cursor: 'pointer'
    },
    viewMapContainer: {
        zIndex: 100,
        position: 'relative',
        margin: 16,
        marginBottom: 24,
        padding: '12px 16px',
        border: "solid 2px #dfe4f0",
        borderRadius: 8,
        backgroundColor: "#fff"
    },
    viewInMapBtn: {
        backgroundColor: "#00875a",
        borderRadius: 8,
        color: "#fff",
        textAlign: 'center',
        padding: "12px 12px",
        textTransform: 'capitalize',
        borderColor: "#00875a",
        marginTop: 12,
        '&:hover': {
            backgroundColor: "#00875a",
        }
    },
    addressDiv: {
        display: "flex",
        fontSize: 12,
        color: '#484e5a',
        marginTop: 12
    },
    locationIcon: {
        fontSize: 16,
        color: '#858991',
        marginTop: 2,
        marginRight: 4
    },
    textFieldInput: {
        padding: '4px !important',
        paddingLeft: '12px !important'
    },
    searchIcon: {
        fontSize: 18,
        color: 'grey'
    }
}));

const mapMarker = L.divIcon({
    iconSize: [24, 31],
    iconAnchor: [10, 30],
    className: `reliance-map-marker`,
    html: `<div class="map-reliance"><img src=${mapIcon} /></div>`
});

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

function SetViewOnClick({ coords }) {
    const map = useMap();
    map.setView(coords, map.getZoom());

    return null;
}

const defaultBounds = [[23.63936, 68.14712], [28.20453, 97.34466]];
const FuelPumpSearch = ({
    // dispatchGetFuelPumps,
    dispatchSearchFuelPumps,
    dispatchGetSuggestedCities,
    coords,
    timestamp, // timestamp of when the last position was retrieved
    isGeolocationAvailable, // boolean flag indicating that the browser supports the Geolocation API
    isGeolocationEnabled, // boolean flag indicating that the user has allowed the use of the Geolocation API
    positionError, // object with the error returned from the Geolocation API call
}) => {

    const classes = useStyles();
    const [searchText, setSearchText] = React.useState(null);
    const [selectedBunk, setSelectedBunk] = React.useState(null);
    const [fuelPumpsData, setFuelPumpsData] = React.useState({});
    const [bounds, setBounds] = React.useState([[21.173553042, 79.070673839]]);
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [value, setValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [initial, setInitial] = React.useState(true);
    const [nearBy, setNearBy] = React.useState(false);

    const location = useLocation();

    const getBounds = (data) => {
        if (data && data.bunks && data.bunks.length > 0) {
            const boundsData = [];
            for (let index = 0; index < data.bunks.length; index++) {
                const bunk = data.bunks[index];
                if (bunk && bunk.location && bunk.location.latitude && bunk.location.longitude) {
                    boundsData.push([Number(bunk.location.latitude), Number(bunk.location.longitude)])
                }
            }
            setBounds(boundsData)
        }
    }

    useEffect(() => {
        dispatchSearchFuelPumps(
            {
                lat: 21.1458,
                lng: 79.0882
            }, (response) => {
                if (response && response.status && response.status.code && response.status.code == 200 && response.response) {
                    setFuelPumpsData(response.response)
                    getBounds(response.response)
                } else {

                }
            }, () => { })
        /*dispatchGetFuelPumps({},(response)=>{
            if (response && response.status && response.status.code && response.status.code ==200 && response.response) {
                setFuelPumpsData(response.response)
                getBounds(response.response)
            }else{

            }
        },()=>{})*/
    }, []);

    useEffect(() => {
        if (value && value.lat && value.lng) {
            dispatchSearchFuelPumps(value, (response) => {
                if (response && response.status && response.status.code && response.status.code == 200 && response.response) {
                    setFuelPumpsData(response.response)
                    getBounds(response.response)
                } else {

                }
            }, () => { })
        }
    }, [value]);

    const fetch = React.useMemo(
        () =>
            throttle((request, callback, failureCallBack) => {
                dispatchGetSuggestedCities(request, callback, failureCallBack);
            }, 100),
        [],
    );

    React.useEffect(() => {
        let active = true;

        if (inputValue === '') {
            setOptions(value ? [value] : []);
            return undefined;
        }

        fetch(inputValue, (results) => {
            if (active) {
                let newOptions = [];

                if (value) {
                    newOptions = [value];
                }

                if (results) {
                    newOptions = [...newOptions, ...results];
                }

                setOptions(newOptions);
            }
        });

        return () => {
            active = false;
        };
    }, [value, inputValue, fetch]);

    const onBunkClick = (bunk) => {
        setInitial(false)
        if (bunk && bunk.location && bunk.location.latitude && bunk.location.longitude) {
            setSelectedBunk(bunk)
            setBounds([[Number(bunk.location.latitude), Number(bunk.location.longitude)]])
        }
    }

    const viewInMap = (bunk, share) => {
        if (bunk && bunk.location && bunk.location.latitude && bunk.location.longitude) {
            let url = '';
            if (share) {
                url = `?shareText=http://www.google.com/maps/place/${Number(bunk.location.latitude)},${Number(bunk.location.longitude)}`;
            } else {
                url = `http://www.google.com/maps/place/${Number(bunk.location.latitude)},${Number(bunk.location.longitude)}`;
            }
            window.open(url, "_blank");
        }
    }

    return (
        <>
            <div className={classes.container}>
                <div className={classes.relianceHeaderCard}>
                    <img src={relianceLogo} className={classes.relianceLogo} />
                    <Typography className={classes.headerTxt}>Find Reliance Petrol Bunks near you</Typography>
                </div>
                <div className={classes.searchContainer}>
                    <Autocomplete
                        freeSolo
                        id="search-city-input"
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.city)}
                        filterOptions={(x) => x}
                        options={options}
                        autoComplete
                        includeInputInList
                        filterSelectedOptions
                        value={value}
                        size="small"
                        disableClearable
                        onChange={(event, newValue) => {
                            setOptions(newValue ? [newValue, ...options] : options);
                            setValue(newValue);
                            setInputValue('');
                            setNearBy(false)
                        }}
                        onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                            setSelectedBunk(null);
                        }}
                        classes={{ inputRoot: classes.textFieldInput }}
                        closeIcon={<ClearIcon className={classes.icon} />}
                        renderInput={(params) => (
                            <TextField
                                {...params} placeholder="Search for a city"
                                labelwidth={0}
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                    ...params.InputProps,
                                    type: 'search',
                                    labelwidth: 0,
                                    startAdornment: <InputAdornment position="start"><SearchIcon className={classes.searchIcon}></SearchIcon></InputAdornment>,
                                }}
                            />
                        )}
                        renderOption={(option) => {
                            const parts = parse(
                                option.city,
                                match(option.city, inputValue),
                            );

                            return (
                                <Grid container alignItems="center">
                                    <Grid item xs>
                                        {parts.map((part, index) => (
                                            <span key={index} style={{ fontWeight: part.highlight ? 700 : 400, color: part.highlight ? '#2c5de5' : '#0b1323' }}>
                                                {part.text}
                                            </span>
                                        ))}
                                    </Grid>
                                </Grid>
                            );
                        }}
                    />
                </div>
                <div className={!selectedBunk ? classes.mapContainer : null}>
                    {!selectedBunk ?
                        (
                            <>
                                <MapContainer bounds={bounds} zoom={13} style={{ height: "180px", width: "100%" }} center={bounds && bounds[0] ? bounds[0] : []}>
                                    <TileLayer
                                        attribution="<a target=&quot;_blank&quot; href=&quot;https://transportbook.in/&quot;>TransportBook</a>"
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <MarkerClusterGroup chunkedLoading={true} maxClusterRadius={60} animate={true}
                                        showCoverageOnHover={false}
                                        onClusterMouseOver={cluster => {
                                            cluster.layer.spiderfy();
                                        }
                                        }
                                        offClusterMouseOver={cluster => {

                                        }
                                        }
                                        onSpiderfied={cluster => {
                                        }
                                        }>
                                        {fuelPumpsData && fuelPumpsData.bunks && fuelPumpsData.bunks.length > 0 ? fuelPumpsData.bunks.map((bunk) => {
                                            return bunk && bunk.location && bunk.location.latitude && bunk.location.longitude ? (<Marker position={[Number(bunk.location.latitude), Number(bunk.location.longitude)]} icon={mapMarker}>
                                                <Popup>
                                                    <div>
                                                        <Typography className={classes.pumpName}>
                                                            {bunk && bunk.bunkName ? bunk.bunkName : ""}
                                                        </Typography>
                                                        <Typography className={classes.pumpLocation}>
                                                            {bunk && bunk.district ? bunk.district : ""}{bunk && bunk.state ? `, ${bunk.state}` : ""}
                                                        </Typography>
                                                    </div>
                                                </Popup>
                                            </Marker>) : null
                                        }) : null}
                                    </MarkerClusterGroup>
                                    <SetViewOnClick coords={bounds && bounds[0] ? bounds[0] : []} />
                                    {/* <Control position="bottomleft" >
                                        <button onClick={() => { fetchNearbyBunks() }} className="near-by-control"><span><NearByIcon style={{ fontSize: 16 }} /> Near You</span></button>
                                    </Control> */}
                                </MapContainer>
                            </>
                        )
                        :
                        (
                            <>
                                <MapContainer zoom={13} style={{ height: "252px", width: "100%" }}>
                                    <TileLayer
                                        attribution="<a target=&quot;_blank&quot; href=&quot;https://transportbook.in/&quot;>TransportBook</a>"
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    {selectedBunk ? <>
                                        {selectedBunk && selectedBunk.location && <Marker position={[Number(selectedBunk.location.latitude), Number(selectedBunk.location.longitude)]} icon={mapMarker}>
                                            <Popup>
                                                <div>
                                                    <Typography className={classes.pumpName}>
                                                        {selectedBunk && selectedBunk.bunkName ? selectedBunk.bunkName : ""}
                                                    </Typography>
                                                    <Typography className={classes.pumpLocation}>
                                                        {selectedBunk && selectedBunk.district ? selectedBunk.district : ""}{selectedBunk && selectedBunk.state ? `, ${selectedBunk.state}` : ""}
                                                    </Typography>
                                                </div>
                                            </Popup>
                                        </Marker>}
                                    </> : null}
                                    <SetViewOnClick coords={bounds && bounds[0] ? bounds[0] : []} />
                                </MapContainer>
                            </>
                        )}
                </div>
                {selectedBunk ? <div className={classes.viewMapContainer}>
                    <div>
                        <Typography className={classes.bunkName}>
                            {selectedBunk && selectedBunk.bunkName ? selectedBunk.bunkName : ""}
                        </Typography>
                        <Typography className={classes.bunkLocation}>
                            {selectedBunk && selectedBunk.district ? selectedBunk.district : ""}{selectedBunk && selectedBunk.state ? `, ${selectedBunk.state}` : ""}
                        </Typography>
                    </div>
                    {selectedBunk && selectedBunk.address && <div className={classes.addressDiv}>
                        <RoomIcon className={classes.locationIcon} />
                        {selectedBunk && selectedBunk.address ? selectedBunk.address : ""}
                    </div>}
                    <div>
                        <Button variant="outlined" fullWidth className={classes.viewInMapBtn} onClick={() => { viewInMap(selectedBunk) }}>
                            View in Map
                        </Button>
                    </div>
                </div> : null}
                <div className={classes.listHeader}>
                    <Typography className={classes.listHead}>
                        {fuelPumpsData && fuelPumpsData.bunks ? <span>{selectedBunk ? fuelPumpsData.bunks.length - 1 : fuelPumpsData.bunks.length}&nbsp;{selectedBunk ? "Other Diesel Bunks in" : "Diesel Bunks"} in <strong>{value && value.city ? value.city : nearBy ? "Your Current Location" : "Nagpur"}</strong></span> : <span>No Bunks</span>}
                    </Typography>
                </div>
                <div className={!selectedBunk ? location.pathname.includes("/diesel-card/single-diesel-card") ? classes.listContainer2 : classes.listContainer : classes.listContainer1} >
                    {fuelPumpsData && fuelPumpsData.bunks && fuelPumpsData.bunks.length > 0 ? fuelPumpsData.bunks.filter(opt => {
                        if (selectedBunk && selectedBunk.bunkName && opt && opt.bunkName && selectedBunk.bunkName == opt.bunkName) {
                            return false
                        } else {
                            return true;
                        }
                    }).map((data) => {
                        return (<div className={classes.listBox} onClick={(e) => { onBunkClick(data) }}>
                            <div>
                                <Typography className={classes.pumpName}>
                                    {data && data.bunkName ? data.bunkName : ""}
                                </Typography>
                                <Typography className={classes.pumpLocation}>
                                    {data && data.district ? data.district : ""}{data && data.state ? `, ${data.state}` : ""}
                                </Typography>
                            </div>
                            <div>
                                <KeyboardArrowRightIcon className={classes.indicator} />
                            </div>
                        </div>)
                    }) : <></>}
                </div>
            </div>
        </>
    )
}
const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    // dispatchGetFuelPumps: (data, onSuccess, onFailure) => { dispatch(getFuelPumps(data, onSuccess, onFailure)) },
    dispatchGetSuggestedCities: (data, onSuccess, onFailure) => { dispatch(getSuggestedCities(data, onSuccess, onFailure)) },
    dispatchSearchFuelPumps: (data, onSuccess, onFailure) => { dispatch(searchFuelPumps(data, onSuccess, onFailure)) },
});
const enhance = compose(
    // geolocated({
    //     positionOptions: {
    //         enableHighAccuracy: true,
    //         maximumAge: 0,
    //         timeout: Infinity,
    //     },
    //     userDecisionTimeout: null,
    //     watchPosition: true,
    // }),
    connect(mapStateToProps, mapDispatchToProps)
);
export default enhance(FuelPumpSearch);
